/* LEHUA · Quick View — abre modal com produto via fetch JSON.
   Click em [data-quickview-handle] no card → abre modal populado. */

(function () {
  'use strict';

  const COLOR_MAP = {
    'preto': '#1a1a1a', 'black': '#1a1a1a',
    'branco': '#f4eee9', 'white': '#f4eee9', 'off-white': '#f4eee9', 'off white': '#f4eee9',
    'cru': '#d4bfa5', 'bege': '#d4bfa5', 'beige': '#d4bfa5',
    'areia': '#c9b89a', 'sand': '#c9b89a',
    'azul': '#1e5a87', 'blue': '#1e5a87',
    'marinho': '#0e3855', 'navy': '#0e3855',
    'celeste': '#88b8d6', 'azul claro': '#88b8d6', 'sky': '#88b8d6', 'light blue': '#88b8d6',
    'caramelo': '#a87b4f', 'camel': '#a87b4f',
    'marrom': '#5c3d24', 'brown': '#5c3d24', 'cafe': '#5c3d24', 'café': '#5c3d24',
    'bronze': '#8c6a3f',
    'verde': '#4a6b3e', 'green': '#4a6b3e',
    'verde militar': '#3a4a3a', 'verde-militar': '#3a4a3a', 'olive': '#3a4a3a', 'oliva': '#3a4a3a', 'military green': '#3a4a3a',
    'verde agua': '#9bcaa8', 'verde-agua': '#9bcaa8', 'mint': '#9bcaa8', 'menta': '#9bcaa8',
    'vermelho': '#a32b2b', 'red': '#a32b2b',
    'vinho': '#5c1f2b', 'bordo': '#5c1f2b', 'bordeaux': '#5c1f2b', 'wine': '#5c1f2b', 'burgundy': '#5c1f2b',
    'rosa': '#e8a5b5', 'pink': '#e8a5b5',
    'amarelo': '#e8c547', 'yellow': '#e8c547',
    'mostarda': '#c8a13c', 'mustard': '#c8a13c',
    'laranja': '#c87543', 'orange': '#c87543', 'terracota': '#c87543', 'terracotta': '#c87543',
    'cinza': '#8a8a8a', 'gray': '#8a8a8a', 'grey': '#8a8a8a',
    'cinza claro': '#c4c4c4', 'light gray': '#c4c4c4', 'light grey': '#c4c4c4',
    'cinza escuro': '#4a4a4a', 'dark gray': '#4a4a4a', 'dark grey': '#4a4a4a', 'chumbo': '#4a4a4a', 'graphite': '#4a4a4a',
    'roxo': '#6b4a8a', 'purple': '#6b4a8a', 'lilás': '#6b4a8a', 'lilas': '#6b4a8a',
    'gelo': '#ebe9e2', 'ice': '#ebe9e2',
    'mescla': '#a89e8e', 'heather': '#a89e8e',
  };

  function colorHex(name) {
    if (!name) return '#999';
    return COLOR_MAP[name.toLowerCase().trim()] || '#999';
  }

  function fmtMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  let modal, body, loading;
  let product = null;
  let selectedOptions = {};

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(() => {
      if (body) body.hidden = true;
      if (loading) loading.style.display = '';
      product = null;
      selectedOptions = {};
    }, 300);
  }
  function onKey(e) { if (e.key === 'Escape') closeModal(); }

  function findOptionIndex(name) {
    if (!product || !product.options) return -1;
    return product.options.findIndex(o => {
      const lc = (typeof o === 'string' ? o : o.name).toLowerCase();
      return lc.includes(name);
    });
  }

  function findVariant() {
    if (!product || !product.variants) return null;
    return product.variants.find(v => {
      return Object.keys(selectedOptions).every(k => v[k] === selectedOptions[k]);
    });
  }

  function updateUI() {
    const variant = findVariant();
    const priceEl = modal.querySelector('[data-lehua-qv-price]');
    const compareEl = modal.querySelector('[data-lehua-qv-compare]');
    const addBtn = modal.querySelector('[data-lehua-qv-add]');
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Indisponível';
      return;
    }
    if (priceEl) priceEl.textContent = fmtMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = fmtMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else compareEl.hidden = true;
    }
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Adicionar ao Carrinho' : 'Esgotado';
    addBtn.dataset.variantId = variant.id;
  }

  function refreshSizeAvailability() {
    if (!product) return;
    const sizeIdx = findOptionIndex('tamanho') !== -1 ? findOptionIndex('tamanho') : findOptionIndex('size');
    if (sizeIdx === -1) return;
    const optKey = 'option' + (sizeIdx + 1);
    modal.querySelectorAll('[data-lehua-qv-sizes] [data-size-value]').forEach(btn => {
      const val = btn.dataset.sizeValue;
      const matchingVariant = product.variants.find(v => v[optKey] === val && Object.keys(selectedOptions).every(k => k === optKey || v[k] === selectedOptions[k]));
      const isAvail = matchingVariant && matchingVariant.available;
      btn.classList.toggle('is-disabled', !isAvail);
    });
  }

  function render() {
    body.hidden = false;
    loading.style.display = 'none';

    const eyebrow = modal.querySelector('[data-lehua-qv-eyebrow]');
    const title = modal.querySelector('[data-lehua-qv-title]');
    const pix = modal.querySelector('[data-lehua-qv-pix]');
    const details = modal.querySelector('[data-lehua-qv-details]');
    const track = modal.querySelector('[data-lehua-qv-track]');
    const thumbs = modal.querySelector('[data-lehua-qv-thumbs]');

    eyebrow.textContent = (product.tags && product.tags[0]) || (product.type || '');
    title.textContent = product.title;
    details.href = product.url;

    // Price
    const v0 = product.variants[0];
    selectedOptions = {};
    product.options.forEach((opt, i) => {
      const optName = typeof opt === 'string' ? opt : opt.name;
      selectedOptions['option' + (i + 1)] = v0['option' + (i + 1)];
    });

    // Pix
    pix.textContent = fmtMoney(Math.round(v0.price * 0.95)) + ' no Pix · 5% off';

    // Media — usa product.media (tem alt) pra poder filtrar por cor; fallback p/ images
    let mediaImgs = (product.media || []).filter(m => m.media_type === 'image').map(m => ({
      src: (m.src || (m.preview_image && m.preview_image.src) || ''),
      color: ((m.alt || '') + '').toLowerCase().trim()
    }));
    if (!mediaImgs.length) {
      const imgs = product.images || (product.featured_image ? [product.featured_image] : []);
      mediaImgs = imgs.map(img => ({ src: typeof img === 'string' ? img : (img.src || ''), color: '' }));
    }
    track.innerHTML = mediaImgs.map((m, i) =>
      '<img src="' + m.src + '" data-img-color="' + m.color + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '">'
    ).join('');
    thumbs.innerHTML = mediaImgs.length > 1 ? mediaImgs.map((m, i) =>
      '<button type="button" class="' + (i === 0 ? 'is-active' : '') + '" data-thumb="' + i + '" data-img-color="' + m.color + '"><img src="' + m.src + '" alt=""></button>'
    ).join('') : '';
    thumbs.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.thumb, 10);
        const slide = track.children[idx];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        thumbs.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // Filtra a galeria pela cor selecionada (igual PDP/card); fallback mostra todas
    function filterGalleryByColor(color) {
      const c = ((color || '') + '').toLowerCase().trim();
      const slides = Array.prototype.slice.call(track.querySelectorAll('img'));
      const tbs = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
      const hasMatch = slides.some(s => s.dataset.imgColor === c);
      slides.forEach(s => { s.style.display = (!hasMatch || s.dataset.imgColor === c) ? '' : 'none'; });
      tbs.forEach(t => { t.style.display = (!hasMatch || t.dataset.imgColor === c) ? '' : 'none'; });
      const fv = slides.filter(s => s.style.display !== 'none')[0];
      if (fv) track.scrollLeft = fv.offsetLeft;
      tbs.forEach(t => t.classList.remove('is-active'));
      const fvt = tbs.filter(t => t.style.display !== 'none')[0];
      if (fvt) fvt.classList.add('is-active');
    }
    modal._lehuaQvFilter = filterGalleryByColor;

    // Color swatches
    const colorIdx = findOptionIndex('cor') !== -1 ? findOptionIndex('cor') : findOptionIndex('color');
    const colorEl = modal.querySelector('[data-lehua-qv-color]');
    if (colorIdx !== -1) {
      const optName = typeof product.options[colorIdx] === 'string' ? product.options[colorIdx] : product.options[colorIdx].name;
      const optKey = 'option' + (colorIdx + 1);
      const values = [...new Set(product.variants.map(v => v[optKey]))];
      const swatches = modal.querySelector('[data-lehua-qv-swatches]');
      const colorName = modal.querySelector('[data-lehua-qv-color-name]');
      colorName.textContent = selectedOptions[optKey] || values[0];
      swatches.innerHTML = values.map(val => {
        const sel = val === selectedOptions[optKey] ? ' is-selected' : '';
        return '<button type="button" class="lehua-qv__swatch' + sel + '" style="background:' + colorHex(val) + '" title="' + val + '" data-color-value="' + val + '" data-option-key="' + optKey + '" aria-label="Cor ' + val + '"></button>';
      }).join('');
      swatches.querySelectorAll('[data-color-value]').forEach(b => {
        b.addEventListener('click', () => {
          selectedOptions[b.dataset.optionKey] = b.dataset.colorValue;
          colorName.textContent = b.dataset.colorValue;
          swatches.querySelectorAll('[data-color-value]').forEach(s => s.classList.remove('is-selected'));
          b.classList.add('is-selected');
          filterGalleryByColor(b.dataset.colorValue);
          refreshSizeAvailability();
          updateUI();
        });
      });
      colorEl.hidden = false;
      // Filtra ja na abertura, pela cor inicial
      filterGalleryByColor(selectedOptions[optKey] || values[0]);
    } else {
      colorEl.hidden = true;
    }

    // Size pills
    const sizeIdx = findOptionIndex('tamanho') !== -1 ? findOptionIndex('tamanho') : findOptionIndex('size');
    const sizeEl = modal.querySelector('[data-lehua-qv-size]');
    if (sizeIdx !== -1) {
      const optKey = 'option' + (sizeIdx + 1);
      const values = [...new Set(product.variants.map(v => v[optKey]))];
      const sizes = modal.querySelector('[data-lehua-qv-sizes]');
      sizes.innerHTML = values.map(val => {
        // Check if any variant with current selected color + this size is available
        const matchingVariant = product.variants.find(v => v[optKey] === val && Object.keys(selectedOptions).every(k => k === optKey || v[k] === selectedOptions[k]));
        const isAvail = matchingVariant && matchingVariant.available;
        const sel = val === selectedOptions[optKey] ? ' is-selected' : '';
        const dis = isAvail ? '' : ' is-disabled';
        return '<button type="button" class="lehua-qv__size' + sel + dis + '" data-size-value="' + val + '" data-option-key="' + optKey + '">' + val + '</button>';
      }).join('');
      sizes.querySelectorAll('[data-size-value]').forEach(b => {
        b.addEventListener('click', () => {
          if (b.classList.contains('is-disabled')) return;
          selectedOptions[b.dataset.optionKey] = b.dataset.sizeValue;
          sizes.querySelectorAll('[data-size-value]').forEach(s => s.classList.remove('is-selected'));
          b.classList.add('is-selected');
          updateUI();
        });
      });
      sizeEl.hidden = false;
    } else {
      sizeEl.hidden = true;
    }

    updateUI();
  }

  function loadProduct(handle) {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : Promise.reject('fetch failed'))
      .then(data => {
        product = data;
        render();
      })
      .catch(err => {
        console.warn('Quick view fetch failed:', err);
        loading.innerHTML = '<span>Erro ao carregar. <a href="/products/' + handle + '">Ver detalhes</a></span>';
      });
  }

  function init() {
    modal = document.getElementById('lehua-quickview');
    if (!modal) return;
    body = modal.querySelector('[data-lehua-qv-body]');
    loading = modal.querySelector('[data-lehua-qv-loading]');

    modal.querySelectorAll('[data-lehua-qv-close]').forEach(el => {
      el.addEventListener('click', closeModal);
    });

    // Add to cart
    const addBtn = modal.querySelector('[data-lehua-qv-add]');
    addBtn.addEventListener('click', () => {
      const variantId = addBtn.dataset.variantId;
      if (!variantId || addBtn.disabled) return;
      const original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adicionando…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
      .then(r => r.json())
      .then(async () => {
        addBtn.textContent = 'Adicionado ✓';
        // Busca o carrinho atualizado e avisa o cart-drawer-component pra RE-RENDERIZAR.
        // Mesmo padrão da PDP (lehua-pdp.js): o componente ouve 'cart:update' e refaz o
        // fetch da seção sozinho. Antes disparávamos 'cart:item:added' (que o drawer NÃO
        // escuta) — por isso o produto só aparecia depois de navegar.
        const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(r => r.json()).catch(() => ({}));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'lehua-quickview', data: { source: 'lehua-quickview', itemCount: cart.item_count } }
        }));
        // mantém a barra de frete em sincronia (ela escuta 'cart:item:added')
        document.dispatchEvent(new CustomEvent('cart:item:added'));
        setTimeout(() => {
          closeModal();
          // Abre o drawer (que já re-renderizou com o item novo)
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], .header-actions__action[aria-haspopup="dialog"]');
            if (trigger) trigger.click();
          }
        }, 600);
      })
      .catch(() => { addBtn.textContent = original; addBtn.disabled = false; });
    });

    // Trigger from cards
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-lehua-quickview]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = trigger.dataset.lehuaQuickview;
      if (!handle) return;
      // Reset modal state
      body.hidden = true;
      loading.style.display = '';
      loading.innerHTML = '<span class="lehua-qv__spinner" aria-hidden="true"></span><span>Carregando…</span>';
      openModal();
      loadProduct(handle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
